<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-col>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          color="primary"
        />
      </v-col>
    </v-row>
    <sequential-entrance from-top>
      <v-row>
        <v-col>
          <base-material-card
            v-if="!loading"
            color="primary"
            icon="mdi-bank"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Note Reader Rejections Site {{ id }} Safe ID {{ safes[0].crypto_idnum }}
              </div>
            </template>
            <v-row>
              <v-spacer />
              <v-btn
                color="warning"
                to="/reportsdevices"
              >
                Return
              </v-btn>
            </v-row>

            <v-row>
              <v-col
                class="xs"
                xl="7"
                lg="6"
                sm="12"
              >
                <apexchart
                  v-if="!loading"
                  type="bar"
                  :options="chartOptions"
                  :series="safesums"
                />
              </v-col>
              <v-col
                xl="5"
                lg="6"
                sm="12"
                class="hidden-sm-and-down xs"
              >
                <apexchart
                  v-if="!loading"
                  type="donut"
                  :options="dchartOptions"
                  :series="notetrend"
                />
              </v-col>
            </v-row>
            <v-divider class="mt-3" />

            <v-data-table
              :headers="headers"
              :items="notereader_data"
              :search="search"
              sort-by="day"
              sort-desc
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  color="white"
                >
                  <v-toolbar-title>Note Reader Rejections by day</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  />

                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  />
                </v-toolbar>
              </template>
              <template v-slot:[`item.sum`]="{ item }">
                {{ format_amt(item.sum) }}
              </template>
              <template v-slot:no-data>
                <div class="display-2 font-weight-light">
                  Sorry, no messages to display for Smart Safe ID {{ id }}
                </div>
                <br>
              </template>
            </v-data-table>
            <v-data-table
              :headers="listheaders"
              :items="notereader_event_list"
              :search="searchlist"
              sort-by="timestamp"
              sort-desc
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  color="white"
                >
                  <v-toolbar-title>Note Reader Rejections Log</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  />

                  <v-text-field
                    v-model="searchlist"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  />
                </v-toolbar>
              </template>
              <template v-slot:no-data>
                <div class="display-2 font-weight-light">
                  Sorry, no messages to display for Smart Safe ID {{ id }}
                </div>
                <br>
              </template>
            </v-data-table>
          </base-material-card>
          <div class="py-3" />
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import { utcToZonedTime, format } from 'date-fns-tz'
  const axios = require('axios')
  var numeral = require('numeral')

  export default {
    name: 'Deposits',
    props: ['id'],

    data () {
      return {
        calculating: true,
        radialseries: [],
        search: '',
        searchlist: '',
        searchman: '',
        options: {
          chart: {
            sparkline: {
              enabled: true
            }
          },
          colors: ['#00aedb'],
          stroke: {
            width: 2,
            curve: 'smooth'
          },
          fill: {
            gradient: {
              shade: 'light',
              type: 'diagonal1',
              shadeIntensity: 0.5,
              gradientToColors: ['#3BA22F'],
              inverseColors: false,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 90, 100],
              colorStops: []
            }
          },
          xaxis: {
            crosshairs: {
              width: 1
            }
          },
          yaxis: {
            min: 0
          },
          title: {
            text: '$135,965',
            offsetX: 0,
            style: {
              fontSize: '24px',
              cssClass: 'apexcharts-yaxis-title'
            }
          },
          subtitle: {
            text: 'Revenue',
            offsetX: 0,
            style: {
              fontSize: '14px',
              cssClass: 'apexcharts-yaxis-title'
            }
          }
        },
        chartOptions: {
          chart: {
            height: 350,
            zoom: {
              enabled: false
            }
          },
          fill: {
            type: 'gradient',
            gradient: {
              gradientToColors: ['#3bd6c6'],
              shadeIntensity: 1,
              opacityFrom: 0.9,
              opacityTo: 0.9,
              stops: [0, 90, 100]
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'smooth'
          },
          title: {
            text: 'Note Reader Rejections by day',
            align: 'left'
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            }
          },
          yaxis: {},
          xaxis: {
            categories: []
          }
        },
        series: [
          {
            name: 'Deposits ',
            data: []
          }
        ],
        headers: [
          { text: 'Date', value: 'day', align: 'left' },
          { text: 'Note Jams', value: 'jams', align: 'center' },
          { text: 'Rejection Count', value: 'rejcount', align: 'center' },
          { text: 'Note Count', value: 'count', align: 'center' },
          { text: 'Reject Event Percent %', value: 'percent', align: 'center' }
        ],
        listheaders: [
          { text: 'Timestamp', value: 'timestamp', align: 'left' },
          { text: 'Event', value: 'event_name', align: 'center' }
        ],
        valid: true,
        graphsums: [],
        graphdays: [],
        error: '',
        dialog: false,
        icons: true,
        centered: true,
        activeBtn: 1,
        grow: true,
        cashinperunit: '',
        loading: false,
        dchartOptions: {
          plotOptions: {
            pie: {
              customScale: 0.8,
              expandOnClick: false,
              donut: {
                size: '70%'
              }
            }
          },
          title: {
            text: 'Note Rejections for last 25 deposits',
            align: 'left'
          },
          chart: {
            type: 'donut'
          },
          labels: ['Accepted Notes', 'Rejected Notes'],
          colors: ['#4CAF50', '#ff9800'],
          legend: {
            position: 'left',
            offsetY: 100,
            height: 230
          },
          responsive: [
            {
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'left'
                }
              }
            }
          ]
        }
      }
    },
    timers: {
      log: { time: 10000, autostart: true, repeat: true }
    },
    computed: {
      safesums () {
        // this.chartOptions.xaxis.categories = ['one', 'two']// this.graphdays
        return [{ name: 'Rejection Events', data: [...this.graphsums] }]
      },
      safe_manual () {
        this.$log.debug(this.$store.getters.getManualDeposits)
        return this.$store.getters.getManualDeposits
      },
      notetrend () {
        let safeid = this.safes[0].crypto_idnum
        let number_of_deposits = this.$store.getters.userdeposits.length
        let reject_eventlist = this.$store.getters.notereadereventlist.filter(
          event => event.crypto_idnum === safeid
        )
        let endTS = this.$store.getters.userdeposits[this.$store.getters.userdeposits.length - 1]
        let valid_rej = 0
        let percent = 0
        let number_of_notes = 0
        let deposits = this.$store.getters.userdeposits.slice(Math.max(this.$store.getters.userdeposits.length - 25, 1))
        let start_time = moment()
        let end_time = moment()

        if (
          deposits[0] &&
          deposits[deposits.length - 1].timestamp
        ) {
          start_time = moment(deposits[0].timestamp)
        // end_time = moment(this.$store.getters.userdeposits[this.$store.getters.userdeposits.length-1].timestamp)
        }
        console.log('deposits length ', deposits.length)
        deposits.forEach(element => {
          if (element.notes) {
            console.log('donut note count element ', element)
            element.notes.forEach(note => {
              number_of_notes += note.count
            })
          }
        })

        reject_eventlist.forEach(event => {
          let record_time = moment(event.timestamp)
          if (record_time.isAfter(start_time)) {
            valid_rej++
          } else {
          // console.log('start time was ', start_time.format('YYYY-MM-DD HH:mm:ss'))
          // console.log('record time was ', record_time.format('YYYY-MM-DD HH:mm:ss'))
          // console.log('end time was ', end_time.format('YYYY-MM-DD HH:mm:ss'))
          // console.log(' throwing out record that did not meet the time frame')
          }
        })
        this.radialseries = [number_of_notes, valid_rej]

        return this.radialseries
      },
      notereader_data () {
        this.$log.debug(
          'cashin values in notereader is ',
          this.$store.getters.cashinvalues
        )
        let cashin = this.$store.getters.cashinvalues
        this.$log.debug(this.$store.getters.notereaderevents)

        // filter this for our site here
        let safeid = this.safes[0].crypto_idnum
        let eventlist = this.$store.getters.notereaderevents
        let jamlist = this.$store.getters.notereaderjams
        this.$log.debug('safe id ', safeid, ' event list ', eventlist)
        let events = eventlist.filter(event => event.crypto_idnum === safeid)
        let jams = jamlist.filter(jam => jam.crypto_idnum === safeid)

        // just go back the last 14 days
        let numberofdays = 14
        let timespan = []
        for (let i = 0; i < numberofdays; i++) {
          timespan.push({
            day: moment()
              .subtract(i + 1, 'day')
              .format('YYYY-MM-DD')
          })
        }
        // on each day get the notes in
        //  get the rejects
        //  get the jams
        //  calculate % rejects on the day
        timespan.forEach(function (element, index) {
          let count = 0
          Object.assign(element, { percent: '0' })
          Object.assign(element, { jams: '0' })
          Object.assign(element, { count: '0' })
          Object.assign(element, { rejcount: '0' })
          let today = moment().format('YYYY-MM-DD')
          let jamrec = jams.find(jam => jam.day === element.day)
          if (jamrec) {
            element.jams = jamrec.jamcount
          }
          let rejrec = events.find(events => events.day === element.day)
          if (rejrec) {
            element.rejcount = rejrec.rejcount
          }
          let daynoterec = cashin.find(noterec => noterec.day === element.day)
          if (daynoterec) {
            element.count = daynoterec.bills
          }
          if (element.rejcount !== 0 && element.count !== 0) {
            let prct = element.rejcount / (element.count + element.rejcount)
            element.percent = numeral(prct).format('0.00%')
          }
        })

        // events.forEach( function (element, index) {
        //   let count = 0
        //   Object.assign(events[index], {percent: '0'})
        //   Object.assign(events[index], {jams: '0'})
        //   Object.assign(events[index], {count: '0'})
        //   cashin.forEach( function (cashinelement, cindex ) {

        //     let today = moment().format('YYYY-MM-DD')
        //     // I never have current days note count so put in 0
        //     if (element.day === today) {
        //       let last = events.length - 1
        //       if ( last > 0 ) {
        //       Object.assign(events[last], {count: 'NA', percent: 'NA'})
        //       }
        //     }
        //     console.log(element.day)
        //     jams.forEach(jam => {
        //       if (element.day === jam.day) {
        //         events[index].jams = jam.jamcount
        //       }
        //     })

        //     if (element.day === cashinelement.day) {
        //       count = cashinelement.ones + cashinelement.fives + cashinelement.tens + cashinelement.twenties + cashinelement.fifties + cashinelement.hundreds
        //       events[index].count = count

        //       let rej = events[index].rejcount
        //       if (count > 0 ) {
        //         let prct = (rej/(count+rej))
        //         events[index].percent = numeral(prct).format('0.00%')
        //       }
        //       else {
        //         events[index].percent = numeral(0).format('0.00%')
        //       }
        //     }
        //   })

        // })
        /*
        // I never have current days note count so put in 0
        this.$log.debug('events length ', events.length)
        let last = events.length - 1
        if ( last > 0 ) {
          Object.assign(events[last], {count: 'NA', percent: 'NA'})
        }
        */
        this.$log.debug(' our specific rec is ', timespan, ' for ', safeid)
        this.graphsums = [...timespan.map(data => data.rejcount)].reverse()
        this.$log.debug('graph sums ', this.graphsums)
        this.graphdays = [...timespan.map(data => data.day)]
        this.chartOptions.xaxis.categories = this.graphdays.reverse()

        return (this.items = timespan)
      },
      notereader_event_list () {
        let safeid = this.safes[0].crypto_idnum
        let safe_events = []
        this.$store.getters.notereadereventlist.forEach(element => {
          if (element.crypto_idnum === safeid) {
            let output
            if (this.sitedetails.timezone && this.sitedetails.timezone === 'EST') {
              // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
              let locdate = element.timestamp
              let timeZone = 'America/New_York'
              let zonedDate = utcToZonedTime(locdate, timeZone)
              // zonedDate could be used to initialize a date picker or display the formatted local date/time

              // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
              let pattern = 'yyyy-MM-dd HH:mm:ss'
              output = format(zonedDate, pattern, { timeZone })
              this.$log.debug(' est format is ', output)
            } else if (this.sitedetails.timezone && this.sitedetails.timezone === 'GMT') {
              // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
              let locdate = element.timestamp
              let timeZone = 'Europe/London'
              let zonedDate = utcToZonedTime(locdate, timeZone)
              // zonedDate could be used to initialize a date picker or display the formatted local date/time

              // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
              let pattern = 'yyyy-MM-dd HH:mm:ss'
              output = format(zonedDate, pattern, { timeZone })
              this.$log.debug(' GMT format is ', output)
            } else if (this.sitedetails.timezone && this.sitedetails.timezone === 'PST') {
              // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
              let locdate = element.timestamp
              let timeZone = 'America/Los_Angeles'
              let zonedDate = utcToZonedTime(locdate, timeZone)
              // zonedDate could be used to initialize a date picker or display the formatted local date/time

              // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
              let pattern = 'yyyy-MM-dd HH:mm:ss'
              output = format(zonedDate, pattern, { timeZone })
              this.$log.debug(' PST format is ', output)
            } else if (this.sitedetails.timezone && this.sitedetails.timezone === 'MST') {
              // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
              let locdate = element.timestamp
              let timeZone = 'America/Denver'
              let zonedDate = utcToZonedTime(locdate, timeZone)
              // zonedDate could be used to initialize a date picker or display the formatted local date/time

              // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
              let pattern = 'yyyy-MM-dd HH:mm:ss'
              output = format(zonedDate, pattern, { timeZone })
              this.$log.debug(' PST format is ', output)
            } else if (this.sitedetails.timezone && this.sitedetails.timezone === 'CST') {
              // Obtain a Date instance that will render the equivalent Berlin time for the UTC date
              let locdate = element.timestamp
              let timeZone = 'America/Chicago'
              let zonedDate = utcToZonedTime(locdate, timeZone)
              // zonedDate could be used to initialize a date picker or display the formatted local date/time

              // Set the output to "1.9.2018 18:01:36.386 GMT+02:00 (CEST)"
              let pattern = 'yyyy-MM-dd HH:mm:ss'
              output = format(zonedDate, pattern, { timeZone })
              this.$log.debug(' PST format is ', output)
            }

            let rec = {
              event_name: 'Note Rejected',
              safeid: safeid,
              timestamp: output
            }
            safe_events.push(rec)
          }
        })
        // filter for our safe id
        return safe_events
      },
      safe_data () {
        this.items = this.$store.getters.userdeposits
        for (let deposit in this.items) {
          let depnotes = this.items[deposit].notes
          let count_ones = 0
          let count_fives = 0
          let count_tens = 0
          let count_twenties = 0
          let count_fifties = 0
          let count_hundreds = 0
          let sum = 0
          Object.assign(this.items[deposit], { ones: 0 })
          Object.assign(this.items[deposit], { fives: 0 })
          Object.assign(this.items[deposit], { tens: 0 })
          Object.assign(this.items[deposit], { twenties: 0 })
          Object.assign(this.items[deposit], { fifties: 0 })
          Object.assign(this.items[deposit], { hundreds: 0 })

          for (let index in depnotes) {
            if (this.items[deposit].notes[index].denom === 1) {
              count_ones = this.items[deposit].notes[index].count
              Object.assign(this.items[deposit], { ones: count_ones })
            } else if (this.items[deposit].notes[index].denom === 5) {
              count_fives = this.items[deposit].notes[index].count
              Object.assign(this.items[deposit], { fives: count_fives })
            } else if (this.items[deposit].notes[index].denom === 10) {
              count_tens = this.items[deposit].notes[index].count
              Object.assign(this.items[deposit], { tens: count_tens })
            } else if (this.items[deposit].notes[index].denom === 20) {
              count_twenties = this.items[deposit].notes[index].count
              Object.assign(this.items[deposit], { twenties: count_twenties })
            } else if (this.items[deposit].notes[index].denom === 50) {
              count_fifties = this.items[deposit].notes[index].count
              Object.assign(this.items[deposit], { fifties: count_fifties })
            } else if (this.items[deposit].notes[index].denom === 100) {
              count_hundreds = this.items[deposit].notes[index].count
              Object.assign(this.items[deposit], { hundreds: count_hundreds })
            }
          }
          sum =
            count_ones * 1 +
            count_fives * 5 +
            count_tens * 10 +
            count_twenties * 20 +
            count_fifties * 50 +
            count_hundreds * 100
          Object.assign(this.items[deposit], { sum: sum })
        // Object.assign(this.items[deposit], {ones:count_ones})
        }

        // lets cut this thing up to how we want it
        // get note count
        // get the days in the array
        this.graphdays = [...this.items.map(data => data.date)]
        this.chartOptions.xaxis.categories = this.graphdays.reverse()
        // get the sums in the array
        // get the days in the array
        let rev = this.items.concat()
        rev.reverse()
        this.graphsums = [...rev.map(data => data.sum)]
        // return this.items
        return this.items
      },
      currentsafes () {
        let oursafes = this.$store.getters.safesstatus
        return oursafes
      },
      totalSales () {
        return this.sales.reduce((acc, val) => acc + val.salesInM, 0)
      }
    },
    watch: {
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 1000)
      }
    },
    created () {
      this.loading = true
      this.graphsums = []
      this.graphdays = ''
      this.$log.debug('ID PASSED ', this.$route.params.id)
      this.id = this.$route.params.id
      this.getsitemap(this.id)

      this.sitedetails = this.$store.getters.loadedSites.find(
        location => this.id === location.idnum
      )

    // this.$store.dispatch('loadsafetransactions', this.$route.params.id)
    },
    destroyed () {
    // this.$store.dispatch('resetsafetransactions')
    },
    methods: {
      log () {
      // this.items = this.$store.getters.cashinvalues
      // this.$log.debug('cheating ', this.items)
      },
      getsitemap (machineid) {
        for (let [key, value] of Object.entries(
          this.$store.getters.loadedSiteProfiles
        )) {
          // this.$log.debug(`${key}: ${value}`)
          if (value.idnum === machineid) {
            if (value.siteunitsprofile) {
              let shop = {
                idnum: key,
                safeids: value.siteunitsprofile
              }
              this.location = shop
              this.safes = shop.safeids
              this.$log.debug('shop is ', shop)
              this.$log.debug('***** looking up cashin for ', this.safes)
              // this.$store.dispatch('loadunitcashin', this.safes)
              this.$store.dispatch('loadmonthcashin', this.safes)
              this.$store.dispatch('loadnotereaderevents')
              this.$store.dispatch('loadnotereaderjams')
              this.$store.dispatch('loadunituserdeposits', this.safes[0])
            // now go get the data for these sites in the shop array
            //
            }
          }
        }
      },
      format_time (ts) {
        return moment(ts).format('DD-MM-YYYY HH:mm:ss')
      },
      format_amt (amt) {
        this.$log.debug('amt ', amt)
        return numeral(amt).format('$0,0.00')
      },
      logErrors (promise) {
        promise.catch(console.error)
      },
      complete (index) {
        this.list[index] = !this.list[index]
      }
    }
  }
</script>
